import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEmberDotJsComponent } from './simple-icons-ember-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEmberDotJsComponent ],
    exports:      [ SimpleIconsEmberDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsEmberDotJsModule {}
